export const saveAs = (valuescsv, csvfilename) => {
  var csvFileName = csvfilename;
  var byteArray = stringToUtf16ByteArray("\uFEFF" + valuescsv);
  var blob = new Blob([new Uint8Array(byteArray)], { type: "text/attachment;charset=UTF-16LE;" });
  var url = URL.createObjectURL(blob);

  var link = document.createElement("a");
  // Browsers that support HTML5 download attribute
  if (typeof link.download === "string") {
    document.body.appendChild(link);
    link.id = "csvDownLink";
    link.setAttribute("download", csvFileName);
    link.setAttribute("href", url);
    link.style.visibility = "hidden";
    link.click();
    document.body.removeChild(link);
  }
  // IE
  else if (msieversion()) {
    var IEwindow = window.open();
    IEwindow.document.write(valuescsv);
    IEwindow.document.close();
    IEwindow.document.execCommand("SaveAs", true, csvFileName);
    IEwindow.close();
  }
  // Other browsers
  else {
    window.open("data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(valuescsv));
  }
};

function stringToUtf16ByteArray(str) {
  var bytes = [];
  //currently the function returns without BOM. Uncomment the next line to change that.
  //bytes.push(255, 254);  //Little Endian Byte Order Marks
  for (var i = 0; i < str.length; ++i) {
    var charCode = str.charCodeAt(i);
    //char > 2 bytes is impossible since charCodeAt can only return 2 bytes
    // little endian, so first the low byte
    bytes.push(charCode & 0xff); //low byte
    bytes.push((charCode & 0xff00) >>> 8); //high byte (might be 0)
  }
  return bytes;
}

function msieversion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    // If IE, return true
    return true;
  } else {
    return false;
  }
}

export const signedNumberString = (number) => {
  return number > 0 ? "+" + number : "" + number;
};
